import { cva } from 'class-variance-authority';

const rangeThumbBaseStyles = [
  'absolute',
  '-top-2',
  'w-5',
  'h-5',
  'rounded-full',
  'cursor-pointer',

  'before:content-[""]',
  'before:absolute',
  'before:top-1/2',
  'before:left-1/2',
  'before:w-10',
  'before:h-10',
];

const bullBaseStyles = [
  'absolute',
  'top-1/2',
  'left-1/2',
  'h-2.5',
  'w-2.5',
  'rounded-full',
  'transform',
  '-translate-x-1/2',
  '-translate-y-1/2',
  'cursor-pointer',
];

const rangeThumbStylesSAG = cva([
  ...rangeThumbBaseStyles,
  'border-2',
  'border-[#005159]',
  'bg-[#D1FFF2]',

  'dark:border-[#00FFB9]',
  'dark:bg-[#001F39]',
]);

const rangeThumbDisabledStylesSAG = cva([
  ...rangeThumbBaseStyles,
  'border-2',
  'border-[#b3b3b3]',
  'bg-[#f2f2f2]',
]);

const bullStylesSAG = cva([
  ...bullBaseStyles,
  'bg-[#005159]',

  'dark:bg-[#00FFB9]',
]);

const rangeThumbStylesSHS = cva([
  ...rangeThumbBaseStyles,
  'border',
  'border-[#b3b3b3]',
  'bg-white',
  'hover:bg-[#f2f2f2]',

  'dark:border-[#808080]',
  'dark:bg-[#1a1a1a]',
  'dark:hover:bg-[#313131]',
]);

const bullStylesSHS = cva([...bullBaseStyles, 'hidden']);

const rangeThumbDisabledStylesSHS = cva([
  ...rangeThumbBaseStyles,
  'border',
  'border-[#b3b3b3]',
  'bg-white',
  'cursor-not-allowed',

  'dark:border-[#808080]',
  'dark:bg-[#1a1a1a]',
]);

export {
  rangeThumbDisabledStylesSAG,
  rangeThumbDisabledStylesSHS,
  rangeThumbStylesSAG,
  rangeThumbStylesSHS,
  bullStylesSAG,
  bullStylesSHS,
};
